import { motion } from 'framer-motion'
import { FlaskConical } from 'lucide-react'
import { PageHeader, fadeUp } from '@personic/shared'
import { buildBreadcrumbs } from '@/config/routes'

export default function Test() {
  const breadcrumbs = buildBreadcrumbs('/settings/calibration/test')

  return (
    <div>
      <PageHeader
        title="Calibration Testing"
        description="Test your calibration settings against sample profiles to verify accuracy."
        breadcrumbs={breadcrumbs}
      />

      <motion.div variants={fadeUp} initial="hidden" animate="visible" className="max-w-4xl">
        <div className="rounded-xl border border-warm-200 bg-white p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-copper-50 flex items-center justify-center">
              <FlaskConical className="w-5 h-5 text-copper-500" />
            </div>
            <h2 className="font-heading font-semibold text-midnight-800">Test Environment</h2>
          </div>
          <p className="text-sm text-warm-500 text-center py-6">
            Submit sample text or voice data to test your current calibration settings. Results will show how the profiling engine interprets the input with your configuration.
          </p>
        </div>
      </motion.div>
    </div>
  )
}
